import { ParametrosRegra } from '../geral/parametrosRegra';
import { Padrao } from '../generic/padrao';

export class SysPesquisaDinamica extends Padrao{

    override idTab = 185;

    parametrosRegra: ParametrosRegra = new ParametrosRegra();
    nome: string;
    grupo: string;
    pesquisa: string;
    geraRel: number;
    geraGrafico: string;
    tipoGrafico: string;
    parametros: string;
    colTitulo: string;
    colValores: string;
    geraRelCalc: string;
    relPaisagem: string;
    agrupamento: string;
    agrupamentoPadrao: string;
    agrupamentoCampos: string;
    operador: string;
    largCampos: string;
    largCamposSub: string;
    paramSub: string;
    detalhe: string;
    impQuebraPag: string;
    tradHeaderWeb: string;
}
